export const QUESTIONS = [
  {
    id: "toon_fox_scarf",
    mode: "classic-toon",
    title: "Fox Scarf",
    prompt: "What is the color of the fox character's scarf?",
    target: { h: 24, s: 86, b: 94 },
    shape: "fox",
    targetPart: "scarf",
    difficulty: "easy"
  },
  {
    id: "toon_robot_antenna",
    mode: "classic-toon",
    title: "Robot Antenna",
    prompt: "What is the color of the robot's antenna?",
    target: { h: 205, s: 78, b: 92 },
    shape: "robot",
    targetPart: "antenna",
    difficulty: "easy"
  },
  {
    id: "toon_wizard_hat",
    mode: "classic-toon",
    title: "Wizard Hat",
    prompt: "What is the color of the tiny wizard hat?",
    target: { h: 265, s: 70, b: 80 },
    shape: "wizard",
    targetPart: "hat",
    difficulty: "medium"
  },
  {
    id: "toon_sleepy_cat_mask",
    mode: "classic-toon",
    title: "Sleepy Cat Mask",
    prompt: "What is the color of the sleepy cat's mask?",
    target: { h: 318, s: 62, b: 88 },
    shape: "cat",
    targetPart: "mask",
    difficulty: "medium"
  },
  {
    id: "toon_dino_belly",
    mode: "classic-toon",
    title: "Dino Belly",
    prompt: "What is the color of the dino's belly?",
    target: { h: 48, s: 55, b: 96 },
    shape: "dino",
    targetPart: "belly",
    difficulty: "easy"
  },
  {
    id: "toon_bunny_bow",
    mode: "classic-toon",
    title: "Bunny Bow",
    prompt: "What is the color of the bunny pilot's bow?",
    target: { h: 350, s: 72, b: 95 },
    shape: "bunny",
    targetPart: "bow",
    difficulty: "easy"
  },
  {
    id: "toon_penguin_cap",
    mode: "classic-toon",
    title: "Penguin Cap",
    prompt: "What is the color of the penguin's little cap?",
    target: { h: 188, s: 68, b: 86 },
    shape: "penguin",
    targetPart: "cap",
    difficulty: "medium"
  },
  {
    id: "toon_moon_moth_wings",
    mode: "classic-toon",
    title: "Moon Moth Wings",
    prompt: "What is the color of the moon moth's wings?",
    target: { h: 74, s: 52, b: 90 },
    shape: "moth",
    targetPart: "wings",
    difficulty: "medium"
  },
  {
    id: "toon_panda_glasses",
    mode: "classic-toon",
    title: "Panda Glasses",
    prompt: "What is the color of the panda inventor's glasses?",
    target: { h: 34, s: 92, b: 98 },
    shape: "panda",
    targetPart: "glasses",
    difficulty: "hard"
  },
  {
    id: "toon_cloud_cape",
    mode: "classic-toon",
    title: "Cloud Cape",
    prompt: "What is the color of the cloud hero's cape?",
    target: { h: 225, s: 76, b: 90 },
    shape: "cloud",
    targetPart: "cape",
    difficulty: "medium"
  },
  {
    id: "toon_sprout_boots",
    mode: "classic-toon",
    title: "Sprout Boots",
    prompt: "What is the color of the sprout explorer's boots?",
    target: { h: 12, s: 66, b: 72 },
    shape: "sprout",
    targetPart: "boots",
    difficulty: "hard"
  },
  {
    id: "toon_octopus_headband",
    mode: "classic-toon",
    title: "Octo Headband",
    prompt: "What is the color of the octopus drummer's headband?",
    target: { h: 154, s: 80, b: 82 },
    shape: "octo",
    targetPart: "headband",
    difficulty: "medium"
  },
  {
    id: "toon_star_ribbon",
    mode: "classic-toon",
    title: "Star Ribbon",
    prompt: "What is the color of the star dancer's ribbon?",
    target: { h: 285, s: 64, b: 95 },
    shape: "star",
    targetPart: "ribbon",
    difficulty: "hard"
  },
  {
    id: "toon_turtle_shell",
    mode: "classic-toon",
    title: "Turtle Shell",
    prompt: "What is the color of the turtle courier's shell plate?",
    target: { h: 112, s: 62, b: 66 },
    shape: "turtle",
    targetPart: "shell",
    difficulty: "medium"
  },
  {
    id: "toon_mushroom_spots",
    mode: "classic-toon",
    title: "Mushroom Spots",
    prompt: "What is the color of the mushroom kid's cap spots?",
    target: { h: 3, s: 78, b: 95 },
    shape: "mushroom",
    targetPart: "spots",
    difficulty: "easy"
  },
  {
    id: "logo_startup_circle",
    mode: "logo-memory",
    title: "Startup Circle",
    prompt: "What is the color of the startup-style logo circle?",
    target: { h: 214, s: 82, b: 92 },
    shape: "logo-orbit",
    targetPart: "circle",
    difficulty: "easy"
  },
  {
    id: "logo_music_wave",
    mode: "logo-memory",
    title: "Music Wave",
    prompt: "What is the color of the music app-style wave?",
    target: { h: 146, s: 72, b: 84 },
    shape: "logo-wave",
    targetPart: "wave",
    difficulty: "medium"
  },
  {
    id: "logo_delivery_badge",
    mode: "logo-memory",
    title: "Delivery Badge",
    prompt: "What is the color of the delivery badge?",
    target: { h: 39, s: 91, b: 96 },
    shape: "logo-badge",
    targetPart: "badge",
    difficulty: "easy"
  },
  {
    id: "logo_browser_ring",
    mode: "logo-memory",
    title: "Browser Ring",
    prompt: "What is the color of the browser-style ring?",
    target: { h: 196, s: 88, b: 87 },
    shape: "logo-ring",
    targetPart: "ring",
    difficulty: "medium"
  },
  {
    id: "logo_chat_bolt",
    mode: "logo-memory",
    title: "Chat Bolt",
    prompt: "What is the color of the chat tool-style bolt?",
    target: { h: 57, s: 84, b: 98 },
    shape: "logo-bolt",
    targetPart: "bolt",
    difficulty: "easy"
  },
  {
    id: "logo_cloud_tile",
    mode: "logo-memory",
    title: "Cloud Tile",
    prompt: "What is the color of the cloud platform-style tile?",
    target: { h: 268, s: 58, b: 86 },
    shape: "logo-tile",
    targetPart: "tile",
    difficulty: "medium"
  },
  {
    id: "logo_pixel_gem",
    mode: "logo-memory",
    title: "Pixel Gem",
    prompt: "What is the color of the pixel shop-style gem?",
    target: { h: 329, s: 76, b: 94 },
    shape: "logo-gem",
    targetPart: "gem",
    difficulty: "medium"
  },
  {
    id: "logo_leaf_mark",
    mode: "logo-memory",
    title: "Leaf Mark",
    prompt: "What is the color of the wellness brand-style leaf?",
    target: { h: 126, s: 62, b: 76 },
    shape: "logo-leaf",
    targetPart: "leaf",
    difficulty: "medium"
  },
  {
    id: "logo_arcade_star",
    mode: "logo-memory",
    title: "Arcade Star",
    prompt: "What is the color of the arcade brand-style star?",
    target: { h: 20, s: 82, b: 96 },
    shape: "logo-star",
    targetPart: "star",
    difficulty: "hard"
  },
  {
    id: "logo_fintech_bar",
    mode: "logo-memory",
    title: "Fintech Bar",
    prompt: "What is the color of the finance app-style rising bar?",
    target: { h: 174, s: 74, b: 79 },
    shape: "logo-bars",
    targetPart: "bar",
    difficulty: "hard"
  },
  {
    id: "flag_nordic_cross",
    mode: "flag-color",
    title: "Nordic Cross",
    prompt: "What is the color of the Nordic cross?",
    target: { h: 52, s: 94, b: 96 },
    shape: "flag-nordic",
    targetPart: "cross",
    difficulty: "easy"
  },
  {
    id: "flag_center_sun",
    mode: "flag-color",
    title: "Center Sun",
    prompt: "What is the color of the center sun?",
    target: { h: 45, s: 88, b: 98 },
    shape: "flag-sun",
    targetPart: "sun",
    difficulty: "easy"
  },
  {
    id: "flag_left_stripe",
    mode: "flag-color",
    title: "Left Stripe",
    prompt: "What is the color of the left stripe?",
    target: { h: 214, s: 72, b: 64 },
    shape: "flag-vertical",
    targetPart: "left",
    difficulty: "medium"
  },
  {
    id: "flag_diagonal_band",
    mode: "flag-color",
    title: "Diagonal Band",
    prompt: "What is the color of the diagonal band?",
    target: { h: 348, s: 80, b: 86 },
    shape: "flag-diagonal",
    targetPart: "band",
    difficulty: "medium"
  },
  {
    id: "flag_center_disc",
    mode: "flag-color",
    title: "Center Disc",
    prompt: "What is the color of the centered disc?",
    target: { h: 0, s: 82, b: 76 },
    shape: "flag-disc",
    targetPart: "disc",
    difficulty: "easy"
  },
  {
    id: "flag_bottom_stripe",
    mode: "flag-color",
    title: "Bottom Stripe",
    prompt: "What is the color of the bottom stripe?",
    target: { h: 118, s: 62, b: 62 },
    shape: "flag-horizontal",
    targetPart: "bottom",
    difficulty: "medium"
  },
  {
    id: "flag_canton_square",
    mode: "flag-color",
    title: "Canton Square",
    prompt: "What is the color of the canton square?",
    target: { h: 225, s: 82, b: 48 },
    shape: "flag-canton",
    targetPart: "canton",
    difficulty: "hard"
  },
  {
    id: "flag_wave_band",
    mode: "flag-color",
    title: "Wave Band",
    prompt: "What is the color of the wavy band?",
    target: { h: 188, s: 70, b: 82 },
    shape: "flag-wave",
    targetPart: "wave",
    difficulty: "hard"
  },
  {
    id: "flag_triangle_field",
    mode: "flag-color",
    title: "Triangle Field",
    prompt: "What is the color of the triangle field?",
    target: { h: 9, s: 78, b: 72 },
    shape: "flag-triangle",
    targetPart: "triangle",
    difficulty: "medium"
  },
  {
    id: "flag_star_cluster",
    mode: "flag-color",
    title: "Star Cluster",
    prompt: "What is the color of the star cluster?",
    target: { h: 50, s: 38, b: 98 },
    shape: "flag-stars",
    targetPart: "stars",
    difficulty: "hard"
  },
  {
    id: "palette_bubblegum",
    mode: "palette",
    title: "Bubblegum Pop",
    prompt: "What is the hero color of the bubblegum toon palette?",
    target: { h: 334, s: 66, b: 98 },
    shape: "palette-bubble",
    targetPart: "hero",
    difficulty: "easy"
  },
  {
    id: "palette_lagoon",
    mode: "palette",
    title: "Lagoon Splash",
    prompt: "What is the anchor color of the lagoon toon palette?",
    target: { h: 184, s: 75, b: 82 },
    shape: "palette-lagoon",
    targetPart: "anchor",
    difficulty: "medium"
  },
  {
    id: "palette_sunset",
    mode: "palette",
    title: "Sunset Snack",
    prompt: "What is the warm pop color of the sunset toon palette?",
    target: { h: 28, s: 88, b: 96 },
    shape: "palette-sunset",
    targetPart: "pop",
    difficulty: "easy"
  },
  {
    id: "palette_mint",
    mode: "palette",
    title: "Mint Arcade",
    prompt: "What is the mint key color in this toon tones palette?",
    target: { h: 152, s: 48, b: 88 },
    shape: "palette-mint",
    targetPart: "key",
    difficulty: "medium"
  },
  {
    id: "palette_midnight",
    mode: "palette",
    title: "Midnight Candy",
    prompt: "What is the deep accent color in the midnight candy palette?",
    target: { h: 248, s: 58, b: 58 },
    shape: "palette-midnight",
    targetPart: "accent",
    difficulty: "hard"
  }
];
